var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.successful)?_c('div',{staticClass:"notification is-success"},[(_vm.dismissible)?_c('button',{staticClass:"delete",on:{"click":_vm.dismiss}}):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }